import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {InvenResultVo} from '../../common/shared/api/nicolas/vo/inven/InvenResultVo.interface';

/**
 * 인벤 검색 목록 조회
 *
 * Origin: pageNicolasApi.getSearchedInvenList
 * API: POST /api/v1/inven/search
 */
export async function postInvenSearch(
  {
    word,
    sort_type,
    type,
    category_uid,
    page,
  }: {
    word: string;
    sort_type: string;
    type: string;
    category_uid: number;
    page: number;
  },
  options?: FetcherOptions
): Promise<ApiResultV2Vo<InvenResultVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/search',
    {
      method: 'POST',
      data: {
        word,
        sort_type,
        type,
        category_uid,
        page,
      },
    },
    options
  );
  return response.data;
}
